import { render, staticRenderFns } from "./Main-conference.vue?vue&type=template&id=ca4af07e&"
import script from "./Main-conference.vue?vue&type=script&lang=js&"
export * from "./Main-conference.vue?vue&type=script&lang=js&"
import style0 from "./Main-conference.vue?vue&type=style&index=0&id=ca4af07e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports